"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GSWrapperComponent = void 0;
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = tslib_1.__importStar(require("react"));
var GSWrapperComponent = /** @class */ (function (_super) {
    tslib_1.__extends(GSWrapperComponent, _super);
    function GSWrapperComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GSWrapperComponent.prototype.render = function () {
        if (!this.props.globalStore) {
            return this.props.children;
        }
        var greenSectionStore = this.props.globalStore.greenSectionStore;
        return (React.createElement(mobx_react_1.Provider, tslib_1.__assign({}, greenSectionStore), this.props.children));
    };
    return GSWrapperComponent;
}(React.Component));
exports.GSWrapperComponent = GSWrapperComponent;
